import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  TextField,
  Container,
  Typography,
  Box,
  Button,
  Grid,
  Switch,
  FormControlLabel,
} from "@mui/material";
import { useNavigate } from "react-router-dom";

const AddGallery = () => {
  const navigate = useNavigate();
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [displayOrder, setDisplayOrder] = useState(0);
  const [isActive, setIsActive] = useState(true);
  const [selectedImage, setSelectedImage] = useState(null);
  const [imagePreview, setImagePreview] = useState("");
  const baseUrl = process.env.REACT_APP_BASE_URL;

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const allowedTypes = [
        "image/jpeg",
        "image/jpg",
        "image/png",
        "image/gif",
      ];
      const maxSize = 5 * 1024 * 1024; // 5MB

      if (!allowedTypes.includes(file.type)) {
        alert("Only JPG, JPEG, PNG, and GIF files are allowed.");
        e.target.value = "";
        return;
      }
      if (file.size > maxSize) {
        alert("Image size must be less than 5MB.");
        e.target.value = "";
        return;
      }

      setSelectedImage(file);
      setImagePreview(URL.createObjectURL(file));
    }
  };

  useEffect(() => {
    return () => {
      if (imagePreview) {
        URL.revokeObjectURL(imagePreview);
      }
    };
  }, [imagePreview]);

  const validateForm = () => {
    if (!title.trim()) {
      alert("Title is required.");
      return false;
    }
    if (!selectedImage) {
      alert("Image is required.");
      return false;
    }
    return true;
  };

  const handleAddImage = async (e) => {
    e.preventDefault();

    if (validateForm()) {
      const formData = new FormData();
      formData.append("title", title);
      formData.append("description", description);
      formData.append("image", selectedImage);
      formData.append("displayOrder", displayOrder);
      formData.append("isActive", isActive);

      try {
        const token = localStorage.getItem("token");
        await axios.post(`${baseUrl}/auth/gallery`, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        });
        alert("Gallery image added successfully");
        navigate("/dashboard/galleries");
      } catch (error) {
        console.error("Error adding gallery image:", error);
        alert(
          "Failed to add image: " +
            (error.response?.data?.error || "Unknown error"),
        );
      }
    }
  };

  return (
    <Container maxWidth="xl">
      <Typography variant="h4" component="h1" sx={{ mt: 2 }} gutterBottom>
        Add Gallery Image
      </Typography>
      <form onSubmit={handleAddImage}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField
              fullWidth
              margin="normal"
              label="Title"
              variant="outlined"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              required
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              margin="normal"
              label="Description (Optional)"
              variant="outlined"
              multiline
              rows={3}
              value={description}
              onChange={(e) => setDescription(e.target.value)}
            />
          </Grid>
          <Grid item xs={12}>
            <Typography variant="subtitle1" sx={{ mt: 2, mb: 1 }}>
              Image
            </Typography>
            <input
              type="file"
              accept="image/*"
              onChange={handleImageChange}
              style={{ margin: "16px 0", display: "block" }}
              required
            />
            {imagePreview && (
              <img
                src={imagePreview}
                alt="Preview"
                style={{
                  maxWidth: "300px",
                  maxHeight: "200px",
                  borderRadius: "8px",
                  marginTop: "8px",
                  display: "block",
                }}
              />
            )}
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              margin="normal"
              label="Display Order"
              variant="outlined"
              type="number"
              value={displayOrder}
              onChange={(e) => setDisplayOrder(parseInt(e.target.value) || 0)}
              helperText="Lower numbers appear first"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <FormControlLabel
              control={
                <Switch
                  checked={isActive}
                  onChange={(e) => setIsActive(e.target.checked)}
                  color="primary"
                />
              }
              label="Active (Show in gallery)"
              sx={{ mt: 3 }}
            />
          </Grid>
        </Grid>
        <Box sx={{ mt: 3, mb: 16 }}>
          <Button
            type="submit"
            variant="contained"
            color="primary"
            sx={{ width: "25%" }}
          >
            Add Image
          </Button>
        </Box>
      </form>
    </Container>
  );
};

export default AddGallery;
